import React, { useState, useEffect } from "react";
import AccountList from "../accountList/AccountList";
import Select from "react-select";
import { connect } from "react-redux";
import { Popup } from "semantic-ui-react";
import Loader from "semantic-ui-react/dist/es/elements/Loader";

import "../PlatformConfig.scss";
import { gettingStartedProgress } from "../../../../../actions/globalAction";

import { ReactComponent as InfoIcon } from "../../../../../assets/svg/info-icon.svg";

function AdditionalDataTiktok(props) {
    const [configureMode, setConfigureMode] = useState({ label: "Account", value: "Account" });

    console.log("len", props.tiktokKeyword.length);

    useEffect(() => {
        if (
            props.validAccounts &&
            props.validAccounts[0]?.account_exist &&
            props.validAccounts[0]?.details[0]?.name.toLowerCase() === props.accountName.toLowerCase()
        ) {
            let country;
            let entity;
            if (props.validAccounts[0].details[0]?.country_id)
                country = props.getCountryList().find((val) => val.value === props.validAccounts[0].details[0]?.country_id);
            if (props.validAccounts[0].details[0]?.entity_sub_type)
                entity = props.entityList.find((val) => val.value === props.validAccounts[0].details[0]?.entity_sub_type);

            props.setValidCountry(country);
            props.setValidEntity(entity);
        }
    }, [props.validAccounts]);

    useEffect(() => {
        props.setValidCountry(null);
    }, [props.location]);

    useEffect(() => {
        props.setValidEntity(null);
    }, [props.entityType]);

    const configureModeList = [
        { label: "Account", value: "Account" },
        { label: "Keywords", value: "Keywords" },
    ];

    const handleConfigureMode = (value) => {
        if (value.value === "Account") {
            setConfigureMode(value);
        } else if (value.value === "Keywords") setConfigureMode(value);
    };

    const handleSetKeyword = (value) => {
        props.setTiktokKeyword(value);
    };

    return (
        <div className="additionalDataInstagram">
            <section className="parentSection">
                <div className="addAccountBlock">
                    <div className="authenticateSection">
                        <section className="leftSection">
                            <Popup
                                inverted
                                content="TikTok"
                                style={{ backgroundColor: "#1f2e3d" }}
                                trigger={
                                    <div>
                                        <img src={props.icon} className="platformIcon" alt="facebook icon" />
                                    </div>
                                }
                            />
                        </section>
                        <div onClick={() => props.closeComponent()}>
                            <button className="common__btn ml-1 backButton">Back to Social Accounts</button>
                        </div>
                    </div>
                    <section className={`add_account-form`}>
                        <div className="field__row m-10">
                            <div className="field__wrap">
                                <label>Configure*</label>
                                <Select
                                    className="platform-list"
                                    value={configureMode}
                                    options={configureModeList}
                                    onChange={handleConfigureMode}
                                    maxMenuHeight={140}
                                    styles={props.customStyle}
                                    components={{ IndicatorSeparator: () => null }}
                                />
                            </div>
                            {configureMode.value === "Keywords" ? (
                                <>
                                    {/* <div className="field__wrap">
                                        <label>Rule Name*</label>
                                        <Input
                                            type="text"
                                            className="add-facebookPost-input fbConfigure_step1"
                                            placeholder="Rule name"
                                            onChange={(ev) => {
                                                props.setTiktokRuleName(ev.target.value);
                                            }}
                                            value={props.tiktokRuleName}
                                        />
                                    </div> */}
                                </>
                            ) : (
                                <>
                                    <div className="field__wrap">
                                        <div>
                                            <label>Account Name*</label>
                                            <Popup
                                                className="account_name__popup"
                                                position="top left"
                                                header="Configuring account name"
                                                //on="click"
                                                pinned
                                                size="tiny"
                                                wide="very"
                                                content="Account name can only contain letters, numbers, underscores, and periods with maximum character length of 24 characters."
                                                // trigger={<Button className="icon" icon="info circle " />}
                                                trigger={<InfoIcon className="account_name__popup--icon" />}
                                            />
                                        </div>
                                        <input
                                            type="text"
                                            className="add__input"
                                            placeholder="Enter Account Name Without @"
                                            value={props.accountName}
                                            onChange={(e) => props.handleUrlChange(e, "TIKTOK")}
                                        />
                                    </div>

                                    {props.isAccountValid && (
                                        <>
                                            <div className="field__wrap">
                                                <label>Location</label>
                                                <Select
                                                    className="platform-list"
                                                    value={props.validCountry || props.location}
                                                    isSearchable
                                                    placeholder="Select Location"
                                                    options={props.getCountryList()}
                                                    onChange={props.handleLocationChange}
                                                    formatOptionLabel={props.formatOptionLabel}
                                                    maxMenuHeight={140}
                                                    styles={props.customStyle}
                                                    isClearable
                                                    components={{ IndicatorSeparator: () => null }}
                                                />
                                            </div>
                                            <div className="field__wrap">
                                                <label>Entity Type</label>
                                                <Select
                                                    className="platform-list"
                                                    value={props.validEntity || props.entityType}
                                                    isSearchable
                                                    placeholder="Select Entity Type"
                                                    options={props.entityList}
                                                    onChange={props.handleEntityTypeChange}
                                                    maxMenuHeight={140}
                                                    styles={props.customStyle}
                                                    isClearable
                                                    components={{ IndicatorSeparator: () => null }}
                                                />
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </section>

                    {configureMode.value === "Keywords" && (
                        <>
                            <div className="field__wrap" style={{ marginTop: "20px" }}>
                                <div>
                                    <label>Keywords and Hashtags*</label>
                                    <Popup
                                        className="account_name__popup"
                                        position="top left"
                                        header="Configuring Keywords"
                                        //on="click"
                                        pinned
                                        size="miny"
                                        wide="very"
                                        content={`Use only keywords separated with OR and enclosed with double quotes. Example - "keyword" OR "#keyword"`}
                                        // trigger={<Button className="icon" icon="info circle " />}
                                        trigger={<InfoIcon className="account_name__popup--icon" />}
                                    />
                                </div>
                                <section className="tiktokKeywords">
                                    <textarea
                                        type="text"
                                        className={`bulk__field ${
                                            props.tiktokKeyword.length !== 0 ? (props.validTiktokKeyword ? "valid__keyword" : "invalid__keyword") : ""
                                        }`}
                                        onChange={(ev) => {
                                            handleSetKeyword(ev.target.value);
                                        }}
                                        value={props.tiktokKeyword}
                                        placeholder={`Use only keywords separated with OR and enclosed with double quotes\nExample - "keyword" OR "#keyword"`}
                                    />
                                </section>
                            </div>
                        </>
                    )}

                    {/* {configureMode.value === "Account" && (
                        <div className={`field__row-normal m-20`}>
                            <button className="common__btn" onClick={() => props.onAddAccount()}>
                                <span> {props.addingAccount ? <Loader active size="small" /> : ""} Add </span>
                            </button>
                        </div>
                    )} */}

                    {configureMode.value === "Account" && (
                        <div className="field__row-normal m-20">
                            <button className="common__btn offset-hieight" onClick={() => props.verifyAccount()}>
                                <span> {props.verifyingAccount ? <Loader active size="small" /> : ""} Verify </span>
                            </button>
                            <p className="ml-1">*Validate to continue account Configuration</p>

                            <button className="common__btn ml-10 offset-hieight" disabled={!props.isAccountValid} onClick={() => props.onAddAccount()}>
                                <span> {props.addingAccount ? <Loader active size="small" /> : ""} Add </span>
                            </button>
                        </div>
                    )}

                    {configureMode.value === "Account" && (
                        <section className={`account__list-table`}>
                            <AccountList
                                isAccountAdded={props.isAccountAdded}
                                accountListData={props.accountListData}
                                deleteAccount={props.deleteAccount}
                                allLocations={props.allLocations}
                            />
                        </section>
                    )}
                </div>
                <div className="saveAndContinue">
                    <button
                        className="common__btn"
                        disabled={(props.accountListData.length === 0 && props.tiktokKeyword === "") || props.validTiktokKeyword === false}
                        onClick={() => props.closeComponent()}>
                        Save and continue
                    </button>
                </div>
            </section>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        gettingStartedProgress: () => dispatch(gettingStartedProgress()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalDataTiktok);
